import FinancialRatioChartData from './FinancialRatioChartData'

export default FinancialRatioChartData
